import { get, post } from "../config/api";

export interface GenerateBilletsPayload {
  contributor_id: string;
  receipt_type_id: number;
  inscriptions_ids: number[];
  email?: string;
  cellphone?: string;
}

export interface GenerateInstallmentsBilletsPayload {
  payment_request_id: number;
  installments: number[];
}

export interface GenerateBilletsResponse {
  [key: string]: unknown;
}

export interface EnableRefisBannerParams {
  inscriptions_ids: number[];
  receipt_type_id?: number;
  contributor_id?: number | string;
  contributor_document?: string;
}

export type EnableRefisBannerResponse = boolean | Record<string, unknown>;

function normalizeBilletValue(response: GenerateBilletsResponse) {
  const normalize = (target: Record<string, unknown>) => {
    const rawValue = target.value;

    if (typeof rawValue === "number") {
      return;
    }

    if (typeof rawValue === "string") {
      const cleaned = rawValue.replace(/[^0-9,.-]/g, "");
      const hasComma = cleaned.includes(",");
      const dotOccurrences = (cleaned.match(/\./g) || []).length;

      let normalized = cleaned;

      if (hasComma) {
        normalized = cleaned.replace(/\./g, "").replace(",", ".");
      } else if (dotOccurrences > 1) {
        normalized = cleaned.replace(/\./g, "");
      }

      const parsed = Number(normalized);
      if (!Number.isNaN(parsed)) {
        target.value = parsed;
      }
    }
  };

  if (response && typeof response === "object") {
    const billet = response as Record<string, unknown>;
    normalize(billet);

    if (billet.billet && typeof billet.billet === "object") {
      normalize(billet.billet as Record<string, unknown>);
    }
  }

  return response;
}

export default class AgilisServices {
  public static async previousBillets(params: { inscriptions_ids: number[] } | GenerateInstallmentsBilletsPayload) {
    const response = await get<{ data: { has_previous_billet: boolean } }>("/agilis/debts/billets/previous", params);
    if (typeof response.data.has_previous_billet !== "boolean") {
      throw new Error("Resposta inválida ao consultar boletos anteriores.");
    }
    return response.data.has_previous_billet;
  }

  public static async generateBillets(payload: GenerateBilletsPayload) {
    const response = await post<GenerateBilletsResponse>("/agilis/debts/billets", payload);
    return normalizeBilletValue(response);
  }

  public static async generateInstallmentsBillets(payload: GenerateInstallmentsBilletsPayload) {
    const response = await post<GenerateBilletsResponse>("/agilis/debts/billets/installments", payload);
    return normalizeBilletValue(response);
  }

  public static async enableRefisBanner(params: EnableRefisBannerParams) {
    return get<EnableRefisBannerResponse>("/agilis/inscriptions/refis/enable_banner", params);
  }
}
